import { render, staticRenderFns } from "./TopCustomersByRevenuesChart.vue?vue&type=template&id=69c1981a&"
import script from "./TopCustomersByRevenuesChart.vue?vue&type=script&lang=js&"
export * from "./TopCustomersByRevenuesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports